import { LOCALE_ID, NgModule } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_BASE_HREF } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { OAuthModule } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ProfileComponent } from './general-components/profile/profile.component';
import { HomeComponent } from './general-components/home/home.component';
import { SuppliersComponent } from './service-components/specials/suppliers/suppliers.component';
import { ProductImportFlowControlComponent } from './service-components/products/import-flow-control/product-import-flow-control/product-import-flow-control.component';
import { KrampPriceExportFlowControlComponent } from './service-components/pricing/kramp-price-export-flow-control/kramp-price-export-flow-control.component';
import { SearchSuppliersPipe } from './service-components/specials/suppliers/search-suppliers.pipe';
import { ReturnFailuresComponent } from './service-components/returns/return-failures/return-failures.component';
import { DispatchFailuresComponent } from './service-components/dispatches/dispatch-failures.component';
import { InvoiceSearchComponent } from './service-components/invoice-search/invoice-search.component';
import { PaymentTermsCheckerComponent } from './service-components/check-payment-terms/check-payment-terms.component';
import { PaymentTermsCustomersComponent } from './service-components/check-payment-terms-customers/check-payment-terms-customers.component';
import { MancosToCheckUpOnComponent } from './service-components/mancos/mancos-to-check-up-on/mancos-to-check-up-on.component';
import { MancosToCheckUpOnSearchPipe } from './service-components/mancos/mancos-to-check-up-on/mancos-to-check-up-on-search.pipe';
import { MancoFilterComponent } from './service-components/mancos/mancos-to-check-up-on/manco-filter/manco-filter.component';
import { MancoFilterPipe } from './service-components/mancos/mancos-to-check-up-on/manco-filter/manco-filter.pipe';
import { MancoDialogComponent } from './service-components/mancos/mancos-to-check-up-on/manco-dialog/manco-dialog.component';
import { MancoFormComponent } from './service-components/mancos/mancos-to-check-up-on/manco-dialog/manco-form/manco-form.component';
import { NewMancoComponent } from './service-components/mancos/new-manco/new-manco.component';
import { NewMancoOrderInfoComponent } from './service-components/mancos/new-manco/new-manco-order-info/new-manco-order-info.component';
import { SalesorderOverviewComponent } from './service-components/salesorders/salesorder-overview/salesorder-overview.component';
import { NewSalesorderComponent } from './service-components/salesorders/new-salesorder/new-salesorder.component';
import { NewSalesorderOrderlinesComponent } from './service-components/salesorders/new-salesorder/new-salesorder-orderlines/new-salesorder-orderlines.component';
import { SOSEmailKrampComponent } from './service-components/sos-email/kramp/sos-email-kramp.component';
import { SOSEmailINDIComponent } from './service-components/sos-email/indi/sos-email-indi.component';
import { SOSEmailForOrdersWithoutResponseComponent } from './service-components/sos-email/indi-no-response/sos-email-indi-no-response.component';
import { SosCustomerListComponent } from './service-components/sos-email/sos-customer-list/sos-customer-list.component';
import { CurrencyFormatPipe } from './pipes/currency/currency-pipe';
import { OmsCustomerLinkPipe } from './pipes/oms-customer-link/oms-customer-link.pipe';
import { OmsOrderLinkPipe } from './pipes/oms-order-link/oms-order-link.pipe';
import { OmsInvoiceLinkPipe } from './pipes/oms-invoice-link/oms-invoice-link.pipe';
import { FreshdeskTicketLinkPipe } from './pipes/freshdesk-ticket-link/freshdesk-ticket-link.pipe';
import { BlindCancellationComponent } from './service-components/order-history/blind-cancellation-update/blind-cancellation-update.component';
import { CleanDatePipe } from './pipes/clean-date/clean-date.pipe';
import { KrampSpecialsComponent } from './service-components/specials/kramp-specials/kramp-specials.component';
import { SearchKrampSpecialsPipe } from './service-components/specials/kramp-specials/search-kramp-specials.pipe';
import { SearchStringArrayPipe } from './utils/search-string-array';
import { NewKrampSpecialComponent } from './service-components/specials/kramp-specials/new-kramp-special/new-kramp-special.component';
import { FeedbackComponent } from './general-components/feedback/feedback.component';
import { KrampSpecialsTableComponent } from './service-components/specials/kramp-specials/kramp-specials-table/kramp-specials-table.component';
import { FestoSpecialsComponent } from './service-components/specials/festo-specials/festo-specials.component';
import { NewFestoSpecialComponent } from './service-components/specials/festo-specials/new-festo-special/new-festo-special.component';
import { FestoSpecialsTableComponent } from './service-components/specials/festo-specials/festo-specials-table/festo-specials-table.component';
import { SearchFestoSpecialsPipe } from './service-components/specials/festo-specials/search-festo-specials.pipe';
import { TUSpecialsComponent } from './service-components/specials/tu-specials/tu-specials.component';
import { NewTUSpecialComponent } from './service-components/specials/tu-specials/new-tu-special/new-tu-special.component';
import { TUSpecialsTableComponent } from './service-components/specials/tu-specials/tu-specials-table/tu-specials-table.component';
import { SearchTUSpecialsPipe } from './service-components/specials/tu-specials/search-tu-specials.pipe';
import { INDISpecialsComponent } from './service-components/specials/indi-specials/indi-specials.component';
import { INDISpecialsTableComponent } from './service-components/specials/indi-specials/indi-specials-table/indi-specials-table.component';
import { NewINDISpecialComponent } from './service-components/specials/indi-specials/new-indi-special/new-indi-special.component';
import { SearchINDISpecialsPipe } from './service-components/specials/indi-specials/search-indi-specials.pipe';
import { PriceCheckerComponent } from './service-components/price-checker/price-checker.component';
import { QuoteLineComponent } from './service-components/price-checker/quote-line/quote-line.component';
import { QuoteTableComponent } from './service-components/price-checker/quote-table/quote-table.component';
import { ReturnsComponent } from './service-components/returns/returns/returns.component';
import { ReturnItemLineComponent } from './service-components/returns/returns/return-item-line/return-item-line.component';
import { ReturnUpdateFeedbackComponent } from './service-components/returns/returns/return-item-line/return-update-feedback/return-update-feedback.component';
import { TooltipModule } from './general-components/tooltip/tooltip.module';
import { ProcessedFilesComponent } from './service-components/returns/returns/processed-files/processed-files.component';
import { utcDatePipe } from './pipes/utc-date/utc-date.pipe';
import { KrampShippingAddressesComponent } from './service-components/kramp-shipping-addresses/kramp-shipping-addresses.component';
import { SearchKrampShippingAddresses } from './service-components/kramp-shipping-addresses/search-kramp-shipping-addresses.pipe';
import { KrampShippingAddressesTableComponent } from './service-components/kramp-shipping-addresses/kramp-shipping-addresses-table/kramp-shipping-addresses-table.component';
import { YesNoPipe } from './pipes/translate-boolean/yes-no.pipe';
import { KrampShippingAddressFormComponent } from './service-components/kramp-shipping-addresses/kramp-shipping-address-form/kramp-shipping-address-form.component';
import { ConnectionFeedbackComponent } from './general-components/connection-status/connection-feedback.component';
import { RemoveValidCharactersPipe } from './pipes/remove-valid-characters/remove-valid-characters.pipe';
import { ScsnCustomersComponent } from './service-components/scsn-customers/scsn-customers.component';
import { ScsnCustomersTableComponent } from './service-components/scsn-customers/scsn-customers-table/scsn-customers-table.component';
import { SearchExtendedSCSNCustomers } from './service-components/scsn-customers/search-scsn-customers.pipe';
import { IcmCustomerLinkPipe } from './pipes/icm-customer-link/icm-customer-link.pipe';
import { ScsnCustomersFormComponent } from './service-components/scsn-customers/scsn-customers-form/scsn-customers-form.component';
import { CustomerInformationComponent } from './service-components/scsn-customers/scsn-customers-form/customer-information/customer-information.component';
import { LoadingWrenchesComponent } from './general-components/loading/loading-wrenches/loading-wrenches.component';
import { LoadingGearsComponent } from './general-components/loading/loading-gears/loading.component';
import { MancoOrderSummaryComponent } from './service-components/mancos/new-manco/manco-order-summary/manco-order-summary.component';
import { FreshdeskOmsOrderLinkPipe } from './pipes/freshdesk-oms-order-link/freshdesk-oms-order-link.pipe';
import { VerkooporderContentLinkPipe } from './pipes/verkooporder-content-link/verkooporder-content-link.pipe';
import { FormValidityDirective } from './general-components/form-controls/form-control-status-directive';
import { NewSalesorderShippingDetailsComponent } from './service-components/salesorders/new-salesorder/new-salesorder-shipping-details/new-salesorder-shipping-details.component';
import { NewSalesorderInvoiceDetailsComponent } from './service-components/salesorders/new-salesorder/new-salesorder-invoice-details/new-salesorder-invoice-details.component';
import { NewSalesorderInfoComponent } from './service-components/salesorders/new-salesorder/new-salesorder-info/new-salesorder-info.component';
import { AtpInfoComponent } from './general-services/atp/atp-info.component';
import { CustomIconComponent } from './general-components/icons/custom-icon/custom-icon.component';
import { DeliveryStatusColumnComponent } from './service-components/mancos/new-manco/new-manco-form/delivery-status-column/delivery-status-column.component';
import { NewMancoFormDeliveryaddressComponent } from './service-components/mancos/new-manco/new-manco-form/new-manco-form-deliveryaddress/new-manco-form-deliveryaddress.component';
import { OrderlineErrorsComponent } from './general-components/orderline-errors/orderline-errors.component';
import { NewMancoSearchFormComponent } from './service-components/mancos/new-manco/new-manco-search-form/new-manco-search-form.component';
import { NewSalesorderSentComponent } from './service-components/salesorders/new-salesorder/new-salesorder-sent/new-salesorder-sent.component';
import { NewMancoFormOrderlinesComponent } from './service-components/mancos/new-manco/new-manco-form/new-manco-form-orderlines/new-manco-form-orderlines.component';
import { NewMancoFormComponent } from './service-components/mancos/new-manco/new-manco-form/new-manco-form.component';
import { SalesorderFilterComponent } from './service-components/salesorders/salesorder-overview/salesorder-filter/salesorder-filter.component';
import { SalesorderFilterPipe } from './service-components/salesorders/salesorder-overview/salesorder-filter/salesorder-filter.pipe';
import { SalesorderSearchPipe } from './service-components/salesorders/salesorder-overview/salesorder-search.pipe';
import { SalesorderOverviewTableComponent } from './service-components/salesorders/salesorder-overview/salesorder-overview-table/salesorder-overview-table.component';
import { SalesorderFilterSameCustomerPipe } from './service-components/salesorders/salesorder-overview/salesorder-same-customer.pipe';
import { NewSalesorderDuplicateVerkooporderComponent } from './service-components/salesorders/new-salesorder/new-salesorder-duplicate-verkooporder/new-salesorder-duplicate-verkooporder.component';
import { BlindSalesorderComponent } from './service-components/salesorders/blind-salesorder/blind-salesorder.component';
import { TrimOnPasteDirective } from './general-components/form-controls/trim-on-paste.directive';
import { CopySpecialDirective } from './general-components/form-controls/copy-specials-info.directive';
import { SmartRoundPipe } from './pipes/smart-round/smart-round.pipe';
import { ProductDownloadsComponent } from './service-components/products/product-downloads/product-downloads.component';
import { ProductImportStatusComponent } from './service-components/products/import-reports/product-import-status/product-import-status.component';
import { ProductImportAreaHistoryComponent } from './service-components/products/import-reports/product-import-area-history/product-import-area-history.component';
import { ImportStagesDiagramComponent } from './general-components/import-stages-diagram/import-stages-diagram.component';
import { provideSseHttpClient } from './general-services/sse-http-client';
import { CopyToClipboardDirective } from './general-components/form-controls/copy-to-clipboard.directive';
import { OrderShipmentInfoComponent } from './service-components/order-shipment-info/order-shipment-info.component';

registerLocaleData(localeNl);

@NgModule({
  declarations: [
    AppComponent,
    ProfileComponent,
    SuppliersComponent,
    ProductImportFlowControlComponent,
    KrampPriceExportFlowControlComponent,
    HomeComponent,
    FeedbackComponent,
    LoadingGearsComponent,
    SearchSuppliersPipe,
    ReturnFailuresComponent,
    DispatchFailuresComponent,
    InvoiceSearchComponent,
    OrderShipmentInfoComponent,
    PaymentTermsCheckerComponent,
    PaymentTermsCustomersComponent,
    MancosToCheckUpOnComponent,
    MancosToCheckUpOnSearchPipe,
    MancoFilterComponent,
    MancoFilterPipe,
    MancoDialogComponent,
    MancoFormComponent,
    AtpInfoComponent,
    NewMancoComponent,
    NewMancoFormComponent,
    NewMancoOrderInfoComponent,
    SalesorderOverviewComponent,
    BlindSalesorderComponent,
    BlindCancellationComponent,
    NewSalesorderComponent,
    NewSalesorderOrderlinesComponent,
    NewSalesorderShippingDetailsComponent,
    NewSalesorderInvoiceDetailsComponent,
    NewSalesorderInfoComponent,
    NewSalesorderDuplicateVerkooporderComponent,
    SalesorderFilterComponent,
    SalesorderOverviewTableComponent,
    SalesorderFilterPipe,
    SalesorderSearchPipe,
    SalesorderFilterSameCustomerPipe,
    DeliveryStatusColumnComponent,
    SOSEmailKrampComponent,
    SOSEmailINDIComponent,
    SOSEmailForOrdersWithoutResponseComponent,
    CurrencyFormatPipe,
    SosCustomerListComponent,
    OmsCustomerLinkPipe,
    OmsOrderLinkPipe,
    OmsInvoiceLinkPipe,
    FreshdeskTicketLinkPipe,
    CleanDatePipe,
    KrampSpecialsComponent,
    SearchKrampSpecialsPipe,
    SearchStringArrayPipe,
    NewKrampSpecialComponent,
    KrampSpecialsTableComponent,
    FestoSpecialsComponent,
    NewFestoSpecialComponent,
    FestoSpecialsTableComponent,
    SearchFestoSpecialsPipe,
    TUSpecialsComponent,
    NewTUSpecialComponent,
    TUSpecialsTableComponent,
    SearchTUSpecialsPipe,
    INDISpecialsComponent,
    INDISpecialsTableComponent,
    NewINDISpecialComponent,
    SearchINDISpecialsPipe,
    PriceCheckerComponent,
    QuoteLineComponent,
    QuoteTableComponent,
    ReturnsComponent,
    ReturnItemLineComponent,
    ReturnUpdateFeedbackComponent,
    ProcessedFilesComponent,
    KrampShippingAddressesComponent,
    SearchKrampShippingAddresses,
    utcDatePipe,
    RemoveValidCharactersPipe,
    KrampShippingAddressesTableComponent,
    YesNoPipe,
    KrampShippingAddressFormComponent,
    ConnectionFeedbackComponent,
    ScsnCustomersComponent,
    ScsnCustomersTableComponent,
    SearchExtendedSCSNCustomers,
    IcmCustomerLinkPipe,
    ScsnCustomersFormComponent,
    CustomerInformationComponent,
    LoadingWrenchesComponent,
    MancoOrderSummaryComponent,
    NewMancoFormOrderlinesComponent,
    NewMancoFormDeliveryaddressComponent,
    OrderlineErrorsComponent,
    NewMancoSearchFormComponent,
    NewSalesorderSentComponent,
    FreshdeskOmsOrderLinkPipe,
    VerkooporderContentLinkPipe,
    CustomIconComponent,
    FormValidityDirective,
    TrimOnPasteDirective,
    CopySpecialDirective,
    CopyToClipboardDirective,
    SmartRoundPipe,
    ProductDownloadsComponent,
    ProductImportStatusComponent,
    ProductImportAreaHistoryComponent,
    ImportStagesDiagramComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    DragDropModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: environment.allowedResourceServerUrls,
        sendAccessToken: true,
      },
    }),
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    { provide: LOCALE_ID, useValue: 'nl-NL' },
    provideHttpClient(withInterceptorsFromDi()),
    provideSseHttpClient(),
    FreshdeskTicketLinkPipe,
    SmartRoundPipe,
  ],
})
export class AppModule {}
